import { useState } from "react";
import { ReactComponent as PersonIcon } from "../../../../../assets/Icons/Pages/Operational/Academic/Attendance/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../../assets/Icons/Pages/Operational/Academic/Attendance/PersonInMobile.svg";
import FilterBtn from "../../../../Universal/FilterBtn.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import TogglePushBtn from "../../../../Universal/TogglePushBtn.component";
const StudentsPageHeaderCustom = ({
  setGenderWaysFilter,
  genderWaysFilter,
}) => {
  const [filteredData, setFilteredData] = useState([]);
  return (
    <div
      className="flex-row align-center justify-start g-05"
      style={{ height: "2.3rem" }}
    >
      <div
        className="flex-row align-center justify-start g-05"
        style={{ flexWrap: "wrap" }}
      >
        <TogglePushBtn
          type="radio"
          setVal={(val) => setGenderWaysFilter(val)}
          name="examreportToggle"
          value={genderWaysFilter}
          icon={
            <PersonIcon
              fill="white"
              style={{ width: "1.3rem", height: "1.3rem" }}
            />
          }
          icontype="svg"
          label="All"
        />
        <TogglePushBtn
          type="radio"
          setVal={(val) => setGenderWaysFilter(val)}
          name="examreportToggle"
          value={genderWaysFilter}
          icon={
            <PersonInMobileIcon
              fill="white"
              style={{ width: "1.3rem", height: "1.3rem" }}
            />
          }
          icontype="svg"
          label="Boys"
        />
        <TogglePushBtn
          type="radio"
          setVal={(val) => setGenderWaysFilter(val)}
          name="examreportToggle"
          value={genderWaysFilter}
          icon={
            <PersonInMobileIcon
              fill="white"
              style={{ width: "1.3rem", height: "1.3rem" }}
            />
          }
          icontype="svg"
          label="Girls"
        />
      </div>
      <FilterBtn
        setFilteredData={setFilteredData}
        filteredData={filteredData}
        filterArray={[
          "I",
          "II",
          "III",
          "IV",
          "V",
          "VI",
          "VII",
          "VIII",
          "IX",
          "X",
        ]}
        btnTitle="Filter"
      />
      <div className="flex-col g-05 align-start justify-end">
        <div className="searchInputContainer">
          <input
            type="text"
            className="pageHeaderInput"
            placeholder="Type for search"
          />
          <button className="searchBtn">
            <img src={SearchIcon} alt="searchBtn" />
          </button>
        </div>
      </div>
      <button className="blueActionBtnLight">Add students</button>
    </div>
  );
};

export default StudentsPageHeaderCustom;
